module.exports = __webpack_public_path__ + "img/lei.ac178f91.png";